var map = {
	"./CalPool/1.png": 9041,
	"./CalPool/2.png": 3613,
	"./CalPool/3.png": 989,
	"./DNS Tunneling/1.png": 3061,
	"./DNS Tunneling/2.png": 149,
	"./InvestingTool/1.png": 2601,
	"./InvestingTool/2.png": 6361,
	"./InvestingTool/3.png": 7566,
	"./InvestingTool/4.png": 702,
	"./Malware Communication/1.png": 5477,
	"./Malware Communication/2.png": 1649,
	"./Malware Communication/3.png": 5941,
	"./Malware Communication/4.png": 1531,
	"./Remote Sensing Data Platform/1.png": 1181,
	"./Remote Sensing Data Platform/2.png": 9903,
	"./Xcite/1.png": 771,
	"./Xcite/2.png": 3916,
	"./Xcite/3.png": 5209
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5083;